var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHospitals = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  width: 54,
  height: 49,
  fill: "none",
  viewBox: "0 0 54 49"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#EFF5FF",
  d: "M51.102 33.975a24 24 0 1 0-45.862 9.9h43.723a23.9 23.9 0 0 0 2.139-9.9"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M3.701 43.876h46.8M1 43.876h1.5M51.701 43.876h1.5"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#DCE9FF",
  strokeLinecap: "round",
  strokeWidth: 0.803,
  d: "M10.492 48.531h1.2M15.604 48.531h24.13M41.693 48.531h1.2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M9.059 19.936h32.248v22.738H9.059z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M9.059 19.936h32.248v22.738H9.059z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M40.895 19.936H9.473a.827.827 0 0 1-.584-1.409.83.83 0 0 1 .584-.242h31.422a.827.827 0 0 1 .583 1.41.83.83 0 0 1-.583.24"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M11.541 10.839h27.287v7.442H11.54z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M11.541 10.839h27.287v7.442H11.54z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M33.451 14.239a.66.66 0 0 0-.487-.639l-.47-.128a27.777 27.777 0 0 0-14.621-.001l-.472.128a.66.66 0 0 0-.487.638v4.043h16.537z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M33.451 14.239a.66.66 0 0 0-.487-.639l-.47-.128a27.8 27.8 0 0 0-7.311-.979v0c-2.47 0-4.928.329-7.31.978l-.472.128a.66.66 0 0 0-.487.638v4.043h16.537z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M38.414 9.186h-26.46a.827.827 0 0 0 0 1.654h26.46a.83.83 0 0 0 .827-.828v0a.827.827 0 0 0-.827-.826"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M30.558 42.674h-10.75v-25.86a.6.6 0 0 1 .6-.6h9.55a.6.6 0 0 1 .6.6z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M30.558 42.674h-10.75v-25.86a.6.6 0 0 1 .6-.6h9.55a.6.6 0 0 1 .6.6z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M31.798 42.674h-13.23V34.59a.6.6 0 0 1 .6-.6h12.03a.6.6 0 0 1 .6.6z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M31.798 42.674h-13.23V34.59a.6.6 0 0 1 .6-.6h12.03a.6.6 0 0 1 .6.6z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M25.184 14.148a3.05 3.05 0 0 0-2.835 1.92l-.06.147v17.777h5.79V16.215l-.06-.148a3.05 3.05 0 0 0-2.835-1.92"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M28.077 21.479v-5.265l-.06-.147a3.053 3.053 0 0 0-5.67 0l-.06.147v11.053z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M25.184 14.148a3.05 3.05 0 0 0-2.835 1.92l-.06.147v17.777h5.79V16.215l-.06-.148a3.05 3.05 0 0 0-2.835-1.92"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M19.807 18.281H9.885v-1.054a.6.6 0 0 1 .6-.6h9.322zM40.478 18.281h-9.921v-1.654h9.321a.6.6 0 0 1 .6.6z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M23.941 35.647h2.48v2.48h-2.48z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m23.941 38.128 2.48-2.481h-2.48z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M23.941 35.647h2.48v2.48h-2.48zM9.059 33.165h7.855M41.307 33.165h-7.442"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M11.127 35.647h1.654v7.028h-1.654z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m11.127 39.974 1.654-1.654v-2.673h-1.654z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M11.127 35.647h1.654v7.028h-1.654z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M11.127 38.126h1.654v2.067h-1.654z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M14.848 35.647H16.5v7.028h-1.653z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.848 39.974 16.5 38.32v-2.673h-1.653z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M14.848 35.647H16.5v7.028h-1.653z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M14.848 38.126H16.5v2.067h-1.653z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M33.865 35.647h1.654v7.028h-1.654z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m33.865 37.714 1.654-1.654v-.413h-1.654z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M33.865 35.647h1.654v7.028h-1.654z"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M33.865 38.126h1.654v2.067h-1.654z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M37.586 35.647h1.654v7.028h-1.654z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m37.586 37.714 1.654-1.654v-.413h-1.654z"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M37.586 35.647h1.654v7.028h-1.654z"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M37.586 38.126h1.654v2.067h-1.654z"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M11.127 22.003h6.615v1.654h-6.615z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.262 22.003h-4.135v1.654h2.48z"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M11.127 22.003h6.615v1.654h-6.615z"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M13.193 22.003h2.48v1.654h-2.48z"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M11.127 25.724h6.615v1.653h-6.615z"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.262 25.724h-4.135v1.653h2.48z"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M11.127 25.724h6.615v1.653h-6.615z"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M13.193 25.724h2.48v1.653h-2.48z"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M11.127 29.444h6.615v1.654h-6.615z"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.262 29.444h-4.135V31.1h2.48z"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M11.127 29.444h6.615v1.654h-6.615z"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M13.193 29.444h2.48v1.654h-2.48z"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M32.625 22.003h6.615v1.654h-6.615z"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M36.76 22.003h-4.135v1.654h2.481z"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M32.625 22.003h6.615v1.654h-6.615z"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M34.695 22.003h2.48v1.654h-2.48z"
})), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M32.625 25.724h6.615v1.653h-6.615z"
})), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M36.76 25.724h-4.135v1.653h2.481z"
})), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M32.625 25.724h6.615v1.653h-6.615z"
})), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M34.695 25.724h2.48v1.653h-2.48z"
})), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M32.625 29.444h6.615v1.654h-6.615z"
})), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M36.76 29.444h-4.135V31.1h2.481z"
})), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M32.625 29.444h6.615v1.654h-6.615z"
})), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M34.695 29.444h2.48v1.654h-2.48zM34.695 25.724h2.48v1.653h-2.48zM34.695 22.003h2.48v1.654h-2.48z"
})), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M34.695 29.444h2.48v1.654h-2.48zM23.941 14.56V33.99M26.424 14.56V33.99M22.29 31.099h5.787M22.29 23.656h5.787M22.29 27.378h5.787"
})), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M13.193 16.627h2.894v1.654h-2.894zM34.277 16.627h2.894v1.654h-2.894z"
})), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19.89 6.292a5.292 5.292 0 1 0 10.585 0 5.292 5.292 0 0 0-10.584 0"
})), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M27.26 5.33h-1.113V4.217a.33.33 0 0 0-.33-.33h-1.264a.33.33 0 0 0-.33.33V5.33H23.11a.33.33 0 0 0-.33.33v1.26a.33.33 0 0 0 .33.332h1.111v1.113a.33.33 0 0 0 .33.33h1.264a.33.33 0 0 0 .33-.33v-1.11h1.113a.33.33 0 0 0 .33-.332v-1.26a.33.33 0 0 0-.329-.333"
})), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M19.89 6.292a5.292 5.292 0 1 0 10.585 0 5.292 5.292 0 0 0-10.584 0"
})), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M48.082 45.527H33.227v-4.74q0-.831.136-1.652l.134-.799a1.396 1.396 0 0 1 1.376-1.165h9.304a1.396 1.396 0 0 1 1.362 1.093l.686 3.085 1.154.289a.93.93 0 0 1 .703.9z"
})), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M36.01 45.992h-2.8a.45.45 0 0 1-.45-.45v-.956a.45.45 0 0 1 .45-.45h2.8zM48.254 45.992h-3.42v-1.856h3.42a.29.29 0 0 1 .291.29v1.276a.29.29 0 0 1-.291.29"
})), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M34.617 45.528a1.393 1.393 0 1 0 2.785 0 1.393 1.393 0 0 0-2.785 0M43.44 45.528a1.393 1.393 0 1 0 2.785 0 1.393 1.393 0 0 0-2.785 0"
})), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M45.604 38.565h-3.56v2.32h4.076z"
})), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M42.045 38.565v2.32h.384l2.321-2.32z"
})), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M45.604 38.565h-3.56v2.32h4.076z"
})), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M42.51 35.314a.93.93 0 0 0-.928.928v.928h1.857v-.928a.93.93 0 0 0-.929-.928"
})), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.204,
  d: "M37.867 39.493v2.785M36.477 40.886h2.785"
})), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M22.29 35.647h1.653v2.48h-1.654z"
})), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.943 36.06v-.413h-1.654v2.067z"
})), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M22.29 35.647h1.653v2.48h-1.654z"
})), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M26.424 35.647h1.653v2.48h-1.653z"
})), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M28.078 36.06v-.413h-1.654v2.067z"
})), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M26.424 35.647h1.653v2.48h-1.653z"
})), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M28.903 38.54a6.6 6.6 0 0 0-3.72-1.24v0a6.6 6.6 0 0 0-3.72 1.24v4.134h7.44z"
})), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M25.183 39.78h-1.354a.3.3 0 0 0-.3.3v2.594h1.654z"
})), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.184 40.4v-.62H23.86a.33.33 0 0 0-.33.33v1.944z"
})), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M25.183 39.78h-1.354a.3.3 0 0 0-.3.3v2.594h1.654z"
})), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
  fill: "#DCE9FF",
  d: "M26.538 39.78h-1.354v2.894h1.654V40.08a.3.3 0 0 0-.3-.3"
})), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M26.838 40.4v-.29a.33.33 0 0 0-.331-.33h-1.323v2.274z"
})), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
  stroke: "#1E255D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.803,
  d: "M26.538 39.78h-1.354v2.894h1.654V40.08a.3.3 0 0 0-.3-.3"
})));
export { SvgHospitals as ReactComponent };